<template>
  <BartenderBar
    class="desktop-player-bar"
    name="desktop-player"
    position="right"
    :modal="false"
  >
    <Player ref="desktopPlayer" />
  </BartenderBar>
</template>

<script setup lang="ts">
import { BartenderBar } from '@fokke-/vue-bartender.js'
</script>

<style lang="scss">
.bartender-bar.desktop-player-bar {
  max-width: var(--player-size);
  padding-top: var(--main-col-spacing-top);
  padding-bottom: var(--main-col-spacing-bottom);
  border-left: solid 1px var(--color-border-light);
  scrollbar-color: var(--color-primary) transparent;
  scrollbar-width: thin;

  // Hide on mobile
  @media (max-width: (config.$bp-desktop - 1px)) {
    display: none;
  }
}
</style>
